import { differenceInHours, format, parseISO } from 'date-fns'

import { DATE_FULL_FORMAT } from '../../../../../../constants/date'
import {
  getMatchCriteria,
  MATCH_CRITERION_STATUS,
} from '../../../../RentalPortalMatch'

import {
  MATCH_REQUEST_HIDDEN_STAGES,
  MATCH_REQUEST_THROTTLE_HOURS,
} from './ApplicantFitCheckBlockRequestRow.constants'

function getApplicantFitCheckThrottleHoursLeft(match) {
  if (!match.last_request_sent_at) {
    return 0
  }

  const sentHoursAgo = differenceInHours(
    new Date(),
    parseISO(match.last_request_sent_at)
  )

  return Math.max(MATCH_REQUEST_THROTTLE_HOURS - sentHoursAgo, 0)
}

function getIsMatchCriterionNotProvided(criterion) {
  return criterion.status === MATCH_CRITERION_STATUS.notProvided
}

export function getApplicantFitCheckMissingCriteria(match) {
  return getMatchCriteria(match).filter(getIsMatchCriterionNotProvided)
}

export function getHasApplicantFitCheckRequestRow({ applicantData, match }) {
  return (
    !MATCH_REQUEST_HIDDEN_STAGES.includes(applicantData?.stage) &&
    getApplicantFitCheckMissingCriteria(match).length > 0
  )
}

export function getApplicantFitCheckRequestState({ match, t }) {
  if (!match.can_request_from_applicant) {
    return {
      disabledReason: t('RentalPortal.MatchRequestNoPermissionKey'),
      isDisabled: true,
    }
  }

  const hoursLeft = getApplicantFitCheckThrottleHoursLeft(match)

  return hoursLeft > 0
    ? {
        disabledReason: t('RentalPortal.MatchRequestThrottledKey', {
          hours: hoursLeft,
        }),
        isDisabled: true,
      }
    : { isDisabled: false }
}

export function getApplicantFitCheckMissingText({ match, t }) {
  return t('RentalPortal.MatchRequestMissingKey', {
    count: getApplicantFitCheckMissingCriteria(match).length,
  })
}

export function getApplicantFitCheckThrottleLine({ match, t }) {
  if (!match.last_request_sent_at) {
    return null
  }

  const hoursLeft = getApplicantFitCheckThrottleHoursLeft(match)

  return hoursLeft > 0
    ? t('RentalPortal.MatchRequestThrottledKey', { hours: hoursLeft })
    : t('RentalPortal.MatchRequestLastSentKey', {
        date: format(parseISO(match.last_request_sent_at), DATE_FULL_FORMAT),
      })
}
